export default "__VITE_ASSET__DoXlHP6d__"